// extracted by mini-css-extract-plugin
module.exports = {"dataItem":"ActivityRowCollapseContent_dataItem__rGuzg","dataItemTitle":"ActivityRowCollapseContent_dataItemTitle__33Vfv"};